import { useTranslation } from 'react-i18next';
import { useDownloadData } from './context';
import { ICommandBarItemProps } from '@fluentui/react';
/**
 * Creates the menu for downloading excel versions of the data
 * @returns {import('@fluentui/react').ICommandBarItemProps}
 */
export const useDownloadMenu = (): ICommandBarItemProps => {
  const [t] = useTranslation('download');
  const { setOpen } = useDownloadData();
  return {
    key: 'downloadButton',
    iconProps: { iconName: 'Download' },
    onClick: () => setOpen(true),
    text: t('Download'),
  };
};
